import useNotifier from '@/shared/lib/use-notifier'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, Button, Input, Label } from '@/shared/ui'
import { ethers } from 'ethers'
import { InfoIcon, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import useRoles from '../lib/use-roles'
import { stringToBytes32 } from '@/shared/lib'
import { LangStore } from '@/shared/model/store'

type Props = {
	id?: `0x${string}`
}
const RolesNpo = ({ id }: Props) => {
	const { getRoles, roles } = useRoles()
	const { contracts } = ContractsStore()
	const [newRoleName, setNewRoleName] = useState<string>('')
	const [newRoleAddress, setNewRoleAddress] = useState<string>('')
	// const [permissions, setPermissions] = useState<string[]>([])
	const { writeContract } = useNotifier()
	const { langPack } = LangStore()

	const createRole = () => {
		const permissions = [
			{
				targetContract: newRoleAddress, // Адрес контракта
				allowedFunctions: []
			}
		]

		writeContract({
			abi: contracts.SavvaNPO.abi,
			address: id || '0x0000000000000000000000000000000000000000',
			functionName: 'createRole',
			args: [stringToBytes32(newRoleName), permissions]
		})
	}

	useEffect(() => {
		if (!id) return
		getRoles(id)
	}, [id])

	return (
		<div>
			<div className='rounded-lg border-[1px] p-4 shadow'>
				<Label>{langPack('npo.add_role')}</Label>
				<div className='flex w-full items-center gap-4'>
					<div className='flex flex-row gap-4'>
						<Input value={newRoleName} onChange={e => setNewRoleName(e.target.value)} placeholder='Role name' />
						<Input
							value={newRoleAddress}
							onChange={e => setNewRoleAddress(e.target.value)}
							placeholder='Contract address'
						/>
					</div>
					<Button onClick={createRole}>{langPack('action.add')}</Button>
				</div>
			</div>
			<div className='mt-5 rounded-lg border-[1px] p-4 shadow'>
				<Label className='mb-2 flex w-full border-b-[1px] border-[#d1d5db] pb-2'>{langPack('npo.roles')}</Label>
				<Accordion type='single' collapsible className='w-full'>
					{roles.length ? (
						roles.map(el => (
							<AccordionItem value={el} key={el}>
								<AccordionTrigger className='font-semibold'>
									{ethers.toUtf8String(el).replace(/\0/g, '')}
								</AccordionTrigger>
								<AccordionContent>
									<div className='flex gap-4'>
										<Button size={'icon'} variant={'secondary'}>
											<InfoIcon />
										</Button>
										<Button size={'icon'} variant={'destructive'}>
											<X />
										</Button>
									</div>
								</AccordionContent>
							</AccordionItem>
						))
					) : (
						<div className='text-[12px] text-[grey]'>{langPack('npo.not_roles_yet')}</div>
					)}
				</Accordion>
			</div>
		</div>
	)
}

export default RolesNpo
